import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

type ConfirmRegisterTypeSwitchDialogProps = {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ConfirmRegisterTypeSwitchDialog({
  open,
  loading,
  onCancel,
  onConfirm,
}: ConfirmRegisterTypeSwitchDialogProps) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel}>
      <DialogTitle>Byt uppladdningstyp?</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Om du byter till det andra alternativet kommer alla filer du redan har laddat upp att raderas. Vill du
          fortsätta?
        </DialogContentText>
      </DialogContent>

      <DialogActions className="!px-[20px] !py-[24px] !justify-between">
        <Button className="w-52 h-12" variant="outlined" color="error" onClick={onCancel} disabled={loading}>
          Avbryt
        </Button>

        <Button
          className="w-52 h-13"
          variant="contained"
          color="primary"
          sx={{
            '&.Mui-disabled': {
              backgroundColor: '#43967680',
              color: 'white',
              opacity: 1,
            },
          }}
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? 'Raderar...' : 'Ja, byt alternativ'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
